import React from 'react'
import PropTypes from 'prop-types'

// import css from './styles.js'
import { _NoResult } from './styles'

const AutoCompleteNoResult = ({ message }) => (
  <_NoResult>
    {message}
  </_NoResult>
)


AutoCompleteNoResult.defaultProps = {
  message: 'No result found',
}

AutoCompleteNoResult.propTypes = {
  message: PropTypes.string,
}

export default AutoCompleteNoResult

